import React, { Dispatch } from 'react';
import { AgentAuthState, AuthAction } from './agentAuthStateReducer';
import { AgentAuthStateContext } from './AgentAuthStateProvider';

export default function useAgentAuthState(): { state: AgentAuthState, dispatch: Dispatch<AuthAction> } {
  const { state, dispatch } = React.useContext(AgentAuthStateContext);
  return { state, dispatch };
}